export default __webpack_public_path__ + "static/media/bell_blue.222d9c21.svg";